(() => {
  'use strict';

  const TOTE_VARIANT_ID = 43552877641846;
  const HERO_URL = 'https://cdn.shopify.com/s/files/1/0700/1017/5606/files/tmo-collection-hero-3-shirts.png?v=1784086770';
  const clean = (text) => String(text || '').replace(/^Exclusive:\s*/i, '');

  function installHero(root) {
    const oldHero = root?.querySelector('.tmo-hero');
    if (!oldHero || oldHero.dataset.finalHero === 'ready') return;

    const hero = document.createElement('div');
    hero.className = 'tmo-final-hero';
    hero.dataset.finalHero = 'ready';

    const image = document.createElement('img');
    image.src = HERO_URL;
    image.alt = 'Build Your TMO Collection — choose any 3 shirts with complimentary tote';
    image.width = 1672;
    image.height = 941;
    image.loading = 'eager';
    image.fetchPriority = 'high';
    image.decoding = 'async';

    hero.appendChild(image);
    oldHero.replaceWith(hero);

    if (!document.getElementById('TmoFinalHeroStyles')) {
      const style = document.createElement('style');
      style.id = 'TmoFinalHeroStyles';
      style.textContent = `
        .tmo-final-hero{width:100%;overflow:hidden;background:#001d16;line-height:0}
        .tmo-final-hero img{display:block;width:100%;height:auto;max-width:none;object-fit:contain;object-position:center}
      `;
      document.head.appendChild(style);
    }
  }

  function init(root) {
    if (!root) return;
    installHero(root);
    if (root.dataset.controller === 'ready') return;

    let products = [];
    try {
      products = JSON.parse(root.querySelector('[data-products]')?.textContent || '[]');
    } catch (error) {
      console.error('[TMO products]', error);
    }

    const slots = [...root.querySelectorAll('[data-slot]')];
    const button = root.querySelector('[data-add]');
    const status = root.querySelector('[data-status]');
    const summaries = [
      root.querySelector('[data-summary-one]'),
      root.querySelector('[data-summary-two]'),
      root.querySelector('[data-summary-three]')
    ];

    if (products.length === 0 || slots.length !== 3 || !button) {
      if (status) status.textContent = 'The collection is temporarily unavailable. Please refresh.';
      return;
    }

    root.dataset.controller = 'ready';

    slots.forEach((slot, index) => {
      const design = slot.querySelector('[data-design]');
      const size = slot.querySelector('[data-size]');
      const image = slot.querySelector('[data-preview]');
      const placeholder = slot.querySelector('[data-placeholder]');
      const mark = slot.querySelector('[data-selected-mark]');

      design.innerHTML = '<option value="">Choose a TMO shirt</option>';
      products.forEach((product, productIndex) => {
        const option = document.createElement('option');
        option.value = String(productIndex);
        option.textContent = clean(product.title);
        design.appendChild(option);
      });
      design.disabled = false;

      design.addEventListener('change', () => {
        size.innerHTML = '<option value="">Select your size</option>';
        size.disabled = true;
        if (mark) mark.style.display = 'none';

        if (design.value === '') {
          if (image) image.style.display = 'none';
          if (placeholder) placeholder.style.display = 'grid';
          if (summaries[index]) summaries[index].textContent = 'Not selected yet';
          update();
          return;
        }

        const product = products[Number(design.value)];
        if (image) {
          image.src = product.image || '';
          image.alt = product.title || '';
          image.style.display = product.image ? 'block' : 'none';
        }
        if (placeholder) placeholder.style.display = product.image ? 'none' : 'grid';

        (product.variants || []).filter((variant) => variant.available !== false).forEach((variant) => {
          const option = document.createElement('option');
          option.value = String(variant.id);
          option.textContent = variant.label || variant.title || 'Select';
          size.appendChild(option);
        });

        size.disabled = false;
        if (summaries[index]) summaries[index].textContent = clean(product.title);
        update();
      });

      size.addEventListener('change', () => {
        const product = design.value !== '' ? products[Number(design.value)] : null;
        if (mark) mark.style.display = size.value ? 'grid' : 'none';
        if (summaries[index]) {
          summaries[index].textContent = size.value && product
            ? `${clean(product.title)} · ${size.options[size.selectedIndex].textContent}`
            : (product ? clean(product.title) : 'Not selected yet');
        }
        update();
      });
    });

    const selectedIds = () => slots.map((slot) => slot.querySelector('[data-size]')?.value).filter(Boolean);

    function update() {
      const count = selectedIds().length;
      button.disabled = count !== 3;
      button.setAttribute('aria-disabled', count === 3 ? 'false' : 'true');
      if (!status) return;
      status.textContent = count === 3
        ? 'Your collection is ready.'
        : count === 2
          ? 'Select one more shirt to complete your collection.'
          : count === 1
            ? 'Select two more shirts to complete your collection.'
            : 'Select all three shirts to complete your collection.';
    }

    button.addEventListener('click', async () => {
      const selected = selectedIds();
      if (selected.length !== 3) return;

      button.disabled = true;
      button.textContent = 'Preparing Your Collection…';
      if (status) status.textContent = 'Adding your collection to cart…';

      const bundleId = `TMO-${Date.now()}`;
      const common = {
        '_TMO Bundle ID': bundleId,
        '_TMO Collection': '3 Shirts + Complimentary Tote'
      };

      const items = selected.map((id, index) => ({
        id: Number(id),
        quantity: 1,
        properties: { ...common, '_TMO Collection Role': `Shirt ${index + 1}` }
      }));

      items.push({
        id: TOTE_VARIANT_ID,
        quantity: 1,
        properties: { ...common, '_TMO Collection Role': 'Complimentary Tote' }
      });

      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 12000);

      try {
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items,
            attributes: {
              'TMO Collection Offer': 'Active',
              'TMO Collection Bundle ID': bundleId,
              'TMO Collection': '3 Shirts + Complimentary Tote'
            }
          }),
          signal: controller.signal
        });

        clearTimeout(timer);
        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || 'Unable to add the collection.');
        }

        location.assign(window.routes?.cart_url || '/cart');
      } catch (error) {
        clearTimeout(timer);
        console.error('[TMO cart]', error);
        if (status) {
          status.textContent = error.name === 'AbortError'
            ? 'Shopify took too long to respond. Please try again.'
            : (error.message || 'Something went wrong. Please try again.');
        }
        button.textContent = 'Complete My Collection';
        update();
      }
    });

    update();
  }

  function boot() {
    document.querySelectorAll('.tmo-bundle').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
